import IStepOneModel from './IStepOneModel';

const StepOneModelInitialState: IStepOneModel = {
  moredEstefadeh: null,
  tip: null,
  noePelak: null,
  noeVasilehNaghleyeh: null,
  brand: null,
  rangCoreId: null,
  saleSakht: null,
  taghvimSaleSakht: null,
  isSefrKilometer: false,
  isPelakKhodroChanged: false,
  hasBimehHistory: true,
};

export default StepOneModelInitialState;
